var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoGuidIcon4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9768_229582",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F6F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9768_229582)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.37207,
    y: 12.5591,
    width: 43.2558,
    height: 55.814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 30,
    cy: 30,
    r: 29.186,
    stroke: "#F5F5F5",
    strokeWidth: 1.62791
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 14.7676,
    y1: 20.1157,
    x2: 45.2327,
    y2: 20.1157,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 14.7676,
    y1: 25.6972,
    x2: 45.2327,
    y2: 25.6972,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    x1: 14.7676,
    y1: 31.2787,
    x2: 45.2327,
    y2: 31.2787,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x1: 14.7676,
    y1: 36.8601,
    x2: 45.2327,
    y2: 36.8601,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x1: 14.7676,
    y1: 42.4416,
    x2: 45.2327,
    y2: 42.4416,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 14.7676,
    y1: 48.0231,
    x2: 45.2327,
    y2: 48.0231,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGuidIcon4);
export default __webpack_public_path__ + "static/media/photo-guid-icon-4.6db77d4b806c51264dec4382d13d07ed.svg";
export { ForwardRef as ReactComponent };